import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { SearchIcon, UploadIcon, ArrowUpIcon, CheckCircleIcon } from 'lucide-react';
export function GiftCard() {
  const giftCards = [{
    name: 'Amazon',
    logo: 'https://logo.clearbit.com/amazon.com',
    rate: '85%',
    minAmount: 25
  }, {
    name: 'Apple',
    logo: 'https://logo.clearbit.com/apple.com',
    rate: '80%',
    minAmount: 10
  }, {
    name: 'Google Play',
    logo: 'https://logo.clearbit.com/google.com',
    rate: '82%',
    minAmount: 10
  }, {
    name: 'Steam',
    logo: 'https://logo.clearbit.com/steampowered.com',
    rate: '75%',
    minAmount: 20
  }, {
    name: 'Spotify',
    logo: 'https://logo.clearbit.com/spotify.com',
    rate: '70%',
    minAmount: 10
  }, {
    name: 'Netflix',
    logo: 'https://logo.clearbit.com/netflix.com',
    rate: '78%',
    minAmount: 25
  }, {
    name: 'Xbox',
    logo: 'https://logo.clearbit.com/xbox.com',
    rate: '72%',
    minAmount: 15
  }, {
    name: 'PlayStation',
    logo: 'https://logo.clearbit.com/playstation.com',
    rate: '74%',
    minAmount: 10
  }];
  return <div data-id="element-361">
      <PageHeader title="Gift Cards" description="Sell your gift cards to us at competitive rates" data-id="element-362" />
      <Card title="Sell Gift Cards" className="mb-6" data-id="element-363">
        <div className="mb-4" data-id="element-364">
          <p className="text-gray-600" data-id="element-365">
            Sell your unused or partially used gift cards to us for immediate
            payment. We offer competitive rates for a wide range of popular gift
            card brands.
          </p>
        </div>
        <div className="relative mb-6" data-id="element-366">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-367">
            <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-368" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search gift cards..." data-id="element-369" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-370">
          {giftCards.map(card => <div key={card.name} className="border rounded-lg p-4 hover:shadow-md transition-shadow" data-id="element-371">
              <div className="flex items-center mb-4" data-id="element-372">
                <img src={card.logo} alt={`${card.name} logo`} className="w-12 h-12 rounded-full object-contain bg-gray-50 p-2" onError={e => {
              ;
              (e.target as HTMLImageElement).src = 'https://via.placeholder.com/150?text=' + card.name;
            }} data-id="element-373" />
                <h3 className="ml-3 font-medium" data-id="element-374">{card.name}</h3>
              </div>
              <div className="flex justify-between mb-4" data-id="element-375">
                <p className="text-sm text-gray-500" data-id="element-376">Min: ${card.minAmount}</p>
                <p className="text-sm font-medium text-green-600" data-id="element-377">
                  Rate: {card.rate}
                </p>
              </div>
              <button className="w-full flex justify-center items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-378">
                <ArrowUpIcon className="h-4 w-4 mr-2" data-id="element-379" />
                Sell Now
              </button>
            </div>)}
        </div>
      </Card>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-380">
        <Card title="How to Sell Your Gift Cards" data-id="element-381">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-382">
            <div className="text-center" data-id="element-383">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white" data-id="element-384">
                <span className="text-xl font-bold" data-id="element-385">1</span>
              </div>
              <h3 className="mt-3 text-lg font-medium" data-id="element-386">Select Gift Card</h3>
              <p className="mt-2 text-sm text-gray-500" data-id="element-387">
                Choose the gift card brand you want to sell from our supported
                list.
              </p>
            </div>
            <div className="text-center" data-id="element-388">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white" data-id="element-389">
                <span className="text-xl font-bold" data-id="element-390">2</span>
              </div>
              <h3 className="mt-3 text-lg font-medium" data-id="element-391">Upload Details</h3>
              <p className="mt-2 text-sm text-gray-500" data-id="element-392">
                Enter the gift card code and upload any required images of the
                card.
              </p>
            </div>
            <div className="text-center" data-id="element-393">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white" data-id="element-394">
                <span className="text-xl font-bold" data-id="element-395">3</span>
              </div>
              <h3 className="mt-3 text-lg font-medium" data-id="element-396">Get Paid</h3>
              <p className="mt-2 text-sm text-gray-500" data-id="element-397">
                After verification, receive instant payment to your Oxy Pay
                account.
              </p>
            </div>
          </div>
        </Card>
        <Card title="Sell Gift Card" data-id="element-398">
          <form className="space-y-4" data-id="element-399">
            <div data-id="element-400">
              <label htmlFor="giftCardType" className="block text-sm font-medium text-gray-700" data-id="element-401">
                Gift Card Type
              </label>
              <select id="giftCardType" name="giftCardType" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-402">
                <option value="" data-id="element-403">Select a gift card</option>
                <option data-id="element-404">Amazon</option>
                <option data-id="element-405">Apple</option>
                <option data-id="element-406">Google Play</option>
                <option data-id="element-407">Steam</option>
                <option data-id="element-408">Spotify</option>
                <option data-id="element-409">Netflix</option>
                <option data-id="element-410">Xbox</option>
                <option data-id="element-411">PlayStation</option>
              </select>
            </div>
            <div data-id="element-412">
              <label htmlFor="cardAmount" className="block text-sm font-medium text-gray-700" data-id="element-413">
                Card Amount ($)
              </label>
              <input type="number" name="cardAmount" id="cardAmount" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter card value" data-id="element-414" />
            </div>
            <div data-id="element-415">
              <label htmlFor="cardCode" className="block text-sm font-medium text-gray-700" data-id="element-416">
                Card Code/Number
              </label>
              <input type="text" name="cardCode" id="cardCode" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter card code" data-id="element-417" />
            </div>
            <div data-id="element-418">
              <label className="block text-sm font-medium text-gray-700" data-id="element-419">
                Upload Card Image (if physical card)
              </label>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" data-id="element-420">
                <div className="space-y-1 text-center" data-id="element-421">
                  <UploadIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-422" />
                  <div className="flex text-sm text-gray-600" data-id="element-423">
                    <label htmlFor="card-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500" data-id="element-424">
                      <span data-id="element-425">Upload image</span>
                      <input id="card-upload" name="card-upload" type="file" className="sr-only" data-id="element-426" />
                    </label>
                    <p className="pl-1" data-id="element-427">or drag and drop</p>
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-428">PNG, JPG up to 5MB</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-4 rounded-md" data-id="element-429">
              <div className="flex items-center" data-id="element-430">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-431" />
                <p className="text-sm text-gray-700" data-id="element-432">
                  You'll receive{' '}
                  <span className="font-bold text-green-600" data-id="element-433">$85.00</span> for
                  this card
                </p>
              </div>
            </div>
            <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-434">
              Submit for Verification
            </button>
          </form>
        </Card>
      </div>
    </div>;
}